export default __webpack_public_path__ + "static/media/christian.e0af4389b131567bdc995aed35863e36.png";